import React, { FC } from 'react';

import { PageHeader } from '../../components/pages/pageHeader/PageHeader';
import { Headline } from '../../components/typography';
import { BodyTemplate } from '../../templates/BodyTemplate';

export const LoadingPageBody: FC = () => {
  return (
    <BodyTemplate>
      <PageHeader>
        <Headline />
      </PageHeader>
    </BodyTemplate>
  );
};
